var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c(
        "el-tooltip",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showWarningImage,
              expression: "showWarningImage"
            }
          ],
          attrs: { content: _vm.warningImageTip, placement: "right-end" }
        },
        [
          _c("i", {
            staticClass: "el-icon-warning red",
            staticStyle: { cursor: "pointer", "font-size": "14px" }
          })
        ]
      ),
      _c("cargo-advance-select", {
        attrs: {
          "select-type": _vm.TYPE_NAMES.basic_data_Company,
          "method-params": _vm.methodParams,
          "hand-trigger-value": _vm.$store.getters.currentOfficeUuid,
          "clear-not-match": _vm.clearNotMatch,
          filterable: "",
          disabled: _vm.disabled,
          "default-value": _vm.value,
          "tag-value": _vm.tagValue,
          headers: _vm.headers,
          fields: _vm.fields,
          "tag-name": _vm.tagName,
          placeholder: _vm.placeholder,
          "static-options": _vm.staticOptions
        },
        on: {
          enter: function($event) {
            return _vm.$emit("enter")
          },
          parentCallBack: _vm.onParentCallBack
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }